// src/pages/NoAccessPage.js
// The only screen a worker with the 'no_access' role ever sees. The API also
// refuses every protected request for that role, so this is a courtesy, not
// the enforcement.
import React, { useContext } from 'react';
import { AuthContext } from '../App';

export default function NoAccessPage() {
  const { worker, logout } = useContext(AuthContext);
  return (
    <div className="screen" style={{ alignItems: 'center', justifyContent: 'center', padding: 24, textAlign: 'center' }}>
      <div style={{ maxWidth: 420 }}>
        <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>🔒</div>
        <h2 style={{ color: 'var(--text-primary)', marginBottom: 12 }}>No access</h2>
        <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 8 }}>
          Your login permissions do not allow access to the information on this site.
        </p>
        <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, marginBottom: 24 }}>
          If you believe this is in error, or would like to request access, please contact your direct supervisor.
        </p>
        {worker?.display_name && (
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: 16 }}>Signed in as {worker.display_name}</p>
        )}
        <button className="btn btn-secondary" style={{ maxWidth: 240, margin: '0 auto' }} onClick={logout}>Sign out</button>
      </div>
    </div>
  );
}
